import { DateHelper } from '../helpers/date.helper';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'errorPrettyDate'})
export class ErrorPrettyDatePipe implements PipeTransform {
  transform(value: Date): string {
    return DateHelper.errorPrettyDate(new Date(value));
  }
}